// @flow
import env from '../../environment';
import {postCreator, getCreator} from '../../http';

export const endpoints = Object.freeze({
  SET_INITIAL_CONFIG: `${env.baseApiUrl}/usher/store/set-initial-config`,
  VALIDATE_DOMAIN: `${env.baseApiUrl}/usher/store/subdomain/available`,
  GET_STORE_TYPES: `${env.baseApiUrl}/usher/store/store-types`,
  SAVE_CANAL_INF: `${env.baseApiUrl}/ui/admin/store/referal-information`,
  SAVE_GOAL_INFORMATION: `${env.baseApiUrl}/ui/admin/store/goal-information`,
  SAVE_SUPPORT_INFORMATION: `${env.baseApiUrl}/ui/admin/store/support-information`,
  GET_GOAL_INFORMATION: `${env.baseApiUrl}/ui/admin/store/goal-information`,
  GET_SUPPORT_INFORMATION: `${env.baseApiUrl}/ui/admin/store/support-information`,
});

export const setInitialConfigApi = postCreator(endpoints.SET_INITIAL_CONFIG);
export const validateDomainApi = postCreator(endpoints.VALIDATE_DOMAIN);
export const getStoreTypesApi = getCreator(endpoints.GET_STORE_TYPES);
export const saveCanalInfApi = postCreator(endpoints.SAVE_CANAL_INF);
export const saveGoalInformationApi = postCreator(
  endpoints.SAVE_GOAL_INFORMATION
);
export const saveSupportInformationApi = postCreator(
  endpoints.SAVE_SUPPORT_INFORMATION
);

export const getGoalInformationApi = getCreator(endpoints.GET_GOAL_INFORMATION);

export const getSupportInformationApi = getCreator(
  endpoints.GET_SUPPORT_INFORMATION
);
